import { AuthService } from 'src/app/services/auth.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorResponse } from '../../models/error.model';
import { UserType } from 'src/app/models/user.model';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SettingsComponent implements OnInit {

    showPassword = false;
    showPasswordConfirm = false;

    userType?: UserType;

    public passwordResetFG = new UntypedFormGroup({
        password: new UntypedFormControl('', [Validators.required]),
        passwordConfirm: new UntypedFormControl('', [Validators.required, control => this.passwordResetFG && control.value !== this.passwordResetFG.value.password ? { notEquals: true } : undefined]),
    });

    constructor(
        private authService: AuthService,
        private utilsService: UtilsService,
    ) { }

    ngOnInit(): void {
        this.userType = this.authService.getUser()?.tipo;
    }

    changePassword() {
        if (this.passwordResetFG.valid) {
            this.authService.changePasswordLogged(this.passwordResetFG.value.password).subscribe(
                _ => this.utilsService.alert('Contraseña cambiada correctamente', 'Ya podés iniciar sesión con tu nueva contraseña'),
                (error: ErrorResponse) => this.utilsService.alert('Error al cambiar contraseña', error.error?.descripcion)
            );
        }
    }
}
